import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { environment } from 'environments/environment';
import { CustomBearerTokenCondition } from 'keycloak-angular';
import Keycloak from 'keycloak-js';

export const keycloakBearerTokenConfig: CustomBearerTokenCondition[] = [
  {
    shouldAddToken: async (req: HttpRequest<unknown>, next: HttpHandlerFn, keycloak: Keycloak) => {
      const url = req.url.toLowerCase();
      const method = req.method.toUpperCase();

      const allowedMethods = ['GET', 'POST', 'PUT', 'DELETE', 'PATCH'];
      if (!allowedMethods.includes(method)) {
        return false;
      }

      const isGoogle = url.includes('maps.google.com');
      const isFileExchange = url.includes('services-emobility.com/files/download');
      const isTranslation = url.includes('services-emobility.com/translations');
      const isBrandingConfig = url.startsWith(environment.brandingConfigUrl.toLowerCase());

      let isCsn: boolean;
      switch (true) {
        case environment.production:
          isCsn = url.includes('csn.vaylens.com');
          break;
        case environment.int:
          isCsn = url.includes('csn-int.vaylens.com');
          break;
        default:
          isCsn = url.includes('csn-qa.vaylens.com');
          break;
      }

      if (isGoogle || isFileExchange || isTranslation || isBrandingConfig || isCsn) {
        return false;
      }

      if (url.startsWith('http://') || url.startsWith('https://')) {
        try {
          const urlObj = new URL(url);
          const hostname = urlObj.hostname;
          const port = urlObj.port;

          const isLocalhost = hostname === 'localhost' && port === '4200';
          const isVaylens = hostname.endsWith('vaylens.com');
          const isEmobility = hostname.endsWith('services-emobility.com');

          if (!(isLocalhost || isVaylens || isEmobility)) {
            return false;
          }
        } catch {
          return false;
        }
      }

      return true;
    },
  },
];
